import { createPayloadAction } from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'

export const setFilterGroup = createPayloadAction<{
  id: string
  filterGroup: FsCore.FilterGroupState
}>('SET_FILTER_GROUP')
export type UseFilterGroupPayload = { filterGroupId: string; usedById: string }
export const useFilterGroup = createPayloadAction<UseFilterGroupPayload>('USE_FILTER_GROUP')
